import { Injectable } from '@angular/core';
import { DropdownService, IDropdownData, IListService } from '@captiveaire/advanceddropdown';
import { QueryService } from '@captiveaire/query';
import { IGridPagedResult } from '../../src/typings/IGridPagedResult';
import { IModuleSummary, IModuleSummarySearchCriteria } from '../../src/typings/models';
import { ProxyService } from '../proxy/ProxyService';
import { StrippedMacPipe } from '../strippedMac/StrippedMacPipe';

@Injectable({
    providedIn: 'root'
})
export class ModuleSummaryService implements IListService {
    public static $name: string = 'moduleSummaryService';

    constructor(
        private dropdownService: DropdownService,
        private queryService: QueryService,
        private proxyService: ProxyService,
        private strippedMacPipe: StrippedMacPipe
    ) {
    }

    public getList(query: IModuleSummarySearchCriteria):
        angular.IPromise<IGridPagedResult<IModuleSummary>> {
        const request = this.queryService.makeRequest(query);
        (request as any).wildcard = this.strippedMacPipe.transform(query.wildcard);
        return this.proxyService.request({
            endPoint: 'module-editor',
            queryParams: request,
            route: 'getModuleList',
        }
        ).as<IGridPagedResult<IModuleSummary>>();
    }

    /* Not implemented */
    public getEndpointName() {
        return 'module-update-context';
    }

    public getListItem(id: string | number): angular.IPromise<IGridPagedResult<IModuleSummary>> {
        return this.proxyService.request({
            endPoint: 'module-editor',
            queryParams: {
                'searchCriteria.id': id,
                'searchCriteria.pagingCriteria.includeTotalCount': false,
                'searchCriteria.pagingCriteria.skip': 0,
                'searchCriteria.pagingCriteria.sortDirection': 0,
                'searchCriteria.pagingCriteria.sortExpressions': ['Id'],
                'searchCriteria.pagingCriteria.take': 1
            },
            route: 'getModuleList'
        }
        ).as<IGridPagedResult<IModuleSummary>>();
    }

    public getModulesForJobNumber(jobNumber: number): angular.IPromise<IModuleSummary[]> {
        return this.proxyService.request({
            endPoint: 'module-editor',
            route: 'getModulesForJobNumber',
            routeParams: {
                jobNumber: jobNumber
            }
        }).asArray<IModuleSummary>();
    }

    public prepareDropdown(moduleId?: number): IDropdownData {
        const dropdown = this.dropdownService.prepareDropdown(
            'Module',
            'description',
            this,
            moduleId);

        dropdown.titleHandler = (item: IModuleSummary) => {
            return `${item.mac}`;
        };

        return dropdown;
    }
}
